import VideoPlayer from '@getaccept/lib-shared-new/src/video/player/components/VideoPlayer.vue';
import { defineComponent, ref } from 'vue';
import EditorNodeWrapper from './EditorNodeWrapper.vue';
export default defineComponent({
    name: 'EditorNodeVideo',
    components: {
        VideoPlayer,
        EditorNodeWrapper,
    },
    props: {
        node: {
            type: Object,
            default: () => ({}),
        },
        blockWidthClass: { type: String, default: null },
    },
    emits: ['observe-node-visibility', 'track-video'],
    setup(props, { emit }) {
        const currentVideoPlayTime = ref(null);
        const handleTimeUpdate = (playtime) => {
            currentVideoPlayTime.value = playtime;
        };
        const sendTrackingData = () => {
            if (!currentVideoPlayTime.value) {
                return;
            }
            emit('track-video', { id: props.node.videoId, viewDuration: currentVideoPlayTime.value });
            currentVideoPlayTime.value = null;
        };
        return {
            handleTimeUpdate,
            sendTrackingData,
            currentVideoPlayTime,
        };
    },
});
